type ReducedMotionListener = (reduced: boolean) => void;

let mq: MediaQueryList | null = null;
const listeners = new Set<ReducedMotionListener>();

const ensureQuery = (): MediaQueryList => {
  if (mq) return mq;
  mq = window.matchMedia("(prefers-reduced-motion: reduce)");
  mq.addEventListener("change", (e) => {
    for (const l of listeners) l(e.matches);
  });
  return mq;
};

/** Возвращает true если пользователь предпочитает уменьшенное движение. */
export const prefersReducedMotion = (): boolean => ensureQuery().matches;

/** Подписывается на изменение prefers-reduced-motion, возвращает отписку. */
export const onReducedMotionChange = (listener: ReducedMotionListener): (() => void) => {
  ensureQuery();
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
};
